import { useEffect, useRef } from "react";

import { MonitoringEventTypeType } from "../../shared/types/monitoring";

import { useCreateMonitoringEvent } from "./use-create-monitoring-event";
import { useHasPoorConnection } from "./use-has-poor-connection";

import { t } from "i18n/i18n";
import { toastWarningMessage } from "utils/alerts";

const NOTIFICATION_COOLDOWN_MS = 5 * 60 * 1000; // 5 minutes to prevent spam

export const useConnectionQualityObserver = () => {
  const hasPoorConnection = useHasPoorConnection();
  const lastNotificationTime = useRef<number>(0);
  const createMonitoringEvent = useCreateMonitoringEvent();

  useEffect(() => {
    const now = Date.now();
    const timeSinceLastNotification = now - lastNotificationTime.current;

    if (hasPoorConnection && timeSinceLastNotification > NOTIFICATION_COOLDOWN_MS) {
      lastNotificationTime.current = now;
      toastWarningMessage(t("connection.poor_connection_warning"));
      createMonitoringEvent(MonitoringEventTypeType.POOR_CONNECTION_WARNING, {});
    }
  }, [hasPoorConnection, createMonitoringEvent]);
};
